<template>
    <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 265 71" style="enable-background: new 0 0 265 71" xml:space="preserve">
        <g class="st0">
            <g>
                <rect x="88.7" y="3.2" class="st1" width="2.1" height="1.9" />
                <rect x="99.3" y="3.2" class="st1" width="2.1" height="1.9" />
                <polygon
                    class="st1"
                    points="99.3,9 97.2,9 97.2,7 99.3,7 99.3,5.1 97.2,5.1 95,5.1 95,5.1 92.9,5.1 90.8,5.1 90.8,7 92.9,7 
			92.9,9 90.8,9 90.8,7 88.7,7 88.7,9 88.7,10.9 90.8,10.9 90.8,12.8 92.9,12.8 92.9,10.9 95,10.9 95,10.9 97.2,10.9 97.2,12.8 
			99.3,12.8 99.3,10.9 99.3,10.9 99.3,10.9 101.4,10.9 101.4,9 101.4,7 99.3,7 		"
                />
            </g>
            <path
                class="st1"
                d="M2.8,3.3h11.1v17.2h0.1c2-4,5.9-5.2,11.8-5.2c6.9,0,16.6,0.3,16.6,13.1v16.9H31.3V28.3c0-2.9-2.3-4.4-7.2-4.4
		h-2.6c-4.8,0-7.6,2.2-7.6,6.4v14.8H2.8V3.3z"
            />
            <path
                class="st1"
                d="M45.4,34.9c0-8.1,5.6-8.5,16.4-8.5c6.1,0,9.5,0.2,11.6,2.4v-2.6c0-2.9-0.9-4-5.2-4h-6.6
		c-3.2,0-4.2,0.3-4.3,2.4H46.5c0-8.1,4-9.3,13.4-9.3h12.9c7.7,0,11.7,3.7,11.7,10.6v19.4H73.9v-3.3c-3.1,3.2-4.2,3.8-9.8,3.8h-7.6
		c-6.8,0-11.1-1.5-11.1-8.4L45.4,34.9z M65.2,38.8c7.7,0,8.4-1.2,8.4-3.1c0-2-0.6-3-6.8-3h-5c-4.7,0-5.7,1-5.7,3.5
		c0,2,1.5,2.7,5.9,2.7H65.2z"
            />
            <path class="st1" d="M100.5,45.2H89.4V15.7h11.1V45.2z" />
            <path class="st1" d="M105.9,3.3h11.1v22.2h2l9.8-9.7h14.6l-14.9,13.9l16.7,15.7h-14.1l-11.9-11.8h-2.2v11.7h-11.1V3.3z" />
            <path
                class="st1"
                d="M145.6,34.9c0-8.1,5.6-8.5,16.4-8.5c6.1,0,9.5,0.2,11.6,2.4v-2.6c0-2.9-0.9-4-5.2-4h-6.6
		c-3.2,0-4.2,0.3-4.3,2.4h-10.8c0-8.1,4-9.3,13.4-9.3H173c7.7,0,11.7,3.7,11.7,10.6v19.4h-10.6v-3.3c-3.1,3.2-4.2,3.8-9.8,3.8h-7.7
		c-6.8,0-11.2-1.5-11.2-8.4L145.6,34.9z M165.5,38.8c7.7,0,8.4-1.2,8.4-3.1c0-2-0.6-3-6.8-3h-4.9c-4.7,0-5.7,1-5.7,3.5
		c0,2,1.5,2.7,5.9,2.7H165.5z"
            />
            <path
                class="st1"
                d="M189,15.7h10.5v5.6h0.1c1.3-4.7,5.8-6.1,10.9-6.1c8.1,0,11.3,3.5,11.3,11.7c0,0.7,0,1.6-0.1,2.6H212
		c0-3.8-0.9-5.6-5.3-5.6c-3.8,0-6.5,1.5-6.5,5v16.2H189V15.7z"
            />
            <path
                class="st1"
                d="M223,34.9c0-8.1,5.6-8.5,16.4-8.5c6.1,0,9.5,0.2,11.6,2.4v-2.6c0-2.9-0.9-4-5.2-4h-6.6c-3.2,0-4.2,0.3-4.3,2.4
		h-10.8c0-8.1,4-9.3,13.4-9.3h13c7.7,0,11.7,3.7,11.7,10.6v19.4h-10.6v-3.3c-3.1,3.2-4.2,3.8-9.8,3.8h-7.6c-6.8,0-11.1-1.5-11.1-8.4
		L223,34.9z M242.8,38.8c7.7,0,8.4-1.2,8.4-3.1c0-2-0.6-3-6.8-3h-4.9c-4.7,0-5.7,1-5.7,3.5c0,2,1.5,2.7,5.9,2.7H242.8z"
            />
            <g>
                <path
                    class="st1"
                    d="M48,63.9V51.3h6.2c1.8,0,3,0.4,3.7,1.2c0.7,0.8,1.1,2.1,1.1,4.1c0,3.2-0.3,5.2-0.9,6.1
			c-0.6,0.9-1.8,1.3-3.8,1.3H48z M50.3,61.9h3.4c1.1,0,1.9-0.3,2.2-0.8c0.3-0.5,0.5-1.7,0.5-3.5c0-1.9-0.2-3-0.5-3.6
			c-0.3-0.5-1-0.8-2.1-0.8h-3.6V61.9z"
                />
                <path class="st1" d="M62.7,51.3V53h-2.1v-1.8H62.7z M62.7,55v8.8h-2.1V55H62.7z" />
                <path
                    class="st1"
                    d="M72.7,55v9c0,1.4-0.3,2.4-0.9,3c-0.6,0.5-1.7,0.8-3.2,0.8c-1.5,0-2.5-0.2-3-0.6s-0.8-1.2-0.8-2.4h2.1
			c0,0.6,0.1,0.9,0.3,1.1c0.2,0.2,0.7,0.2,1.4,0.2c1.3,0,2-0.5,2-1.6v-2l0,0c-0.4,0.9-1.2,1.4-2.6,1.4c-1.3,0-2.3-0.3-2.7-1
			c-0.5-0.6-0.7-1.9-0.7-3.6c0-1.7,0.2-2.8,0.7-3.4c0.5-0.6,1.4-1,2.7-1c1.4,0,2.3,0.5,2.8,1.6h0L70.6,55H72.7z M68.5,56.6
			c-0.8,0-1.3,0.2-1.6,0.5c-0.2,0.3-0.3,1.1-0.3,2.3c0,1.2,0.1,2,0.3,2.4c0.2,0.3,0.8,0.5,1.6,0.5c0.8,0,1.4-0.2,1.6-0.5
			s0.4-1.1,0.4-2.4c0-1.2-0.1-1.9-0.4-2.3S69.4,56.6,68.5,56.6z"
                />
                <path class="st1" d="M76.9,51.3V53h-2.1v-1.8H76.9z M76.9,55v8.8h-2.1V55H76.9z" />
                <path
                    class="st1"
                    d="M84.7,55v1.6h-3.4v4.4c0,0.8,0.3,1.2,0.9,1.2c0.7,0,1-0.5,1-1.5v-0.4h1.8v0.4c0,0.4,0,0.8,0,1
			c-0.1,1.3-1.1,2-3,2c-1.9,0-2.8-0.9-2.8-2.6v-4.7H78V55h1.1v-2h2.1v2H84.7z"
                />
                <path
                    class="st1"
                    d="M88.4,57.6h-2.2c0-1.1,0.2-1.8,0.7-2.1s1.5-0.5,2.9-0.5c1.6,0,2.7,0.2,3.2,0.7c0.6,0.4,0.8,1.3,0.8,2.5v5.8
			h-2.1l0.1-1.2l-0.1,0c-0.4,0.9-1.3,1.3-2.8,1.3c-2.1,0-3.2-0.9-3.2-2.7c0-1.8,1.1-2.8,3.3-2.8c1.5,0,2.3,0.3,2.7,1h0v-1.4
			c0-0.7-0.1-1.1-0.4-1.4c-0.2-0.2-0.7-0.3-1.5-0.3C89,56.4,88.4,56.8,88.4,57.6z M89.8,59.9c-1.2,0-1.8,0.4-1.8,1.2
			c0,0.6,0.1,0.9,0.4,1.1s0.8,0.3,1.6,0.3c1.3,0,1.9-0.4,1.9-1.3C91.9,60.4,91.2,59.9,89.8,59.9z"
                />
                <path class="st1" d="M98.2,51.3v12.6h-2.1V51.3H98.2z" />
                <path class="st1" d="M107.5,51.3v10.5h5.9v2.1h-8.3V51.3H107.5z" />
                <path
                    class="st1"
                    d="M120.3,61h2.1v0.3c0,1.7-1.3,2.6-3.9,2.6c-1.8,0-2.9-0.3-3.4-0.9c-0.5-0.6-0.8-1.9-0.8-3.8
			c0-1.7,0.3-2.9,0.9-3.5c0.6-0.6,1.7-0.9,3.3-0.9c1.6,0,2.6,0.3,3.2,0.9c0.5,0.6,0.8,1.7,0.8,3.4v0.6h-6c0,0.2,0,0.3,0,0.4
			c0,0.9,0.1,1.4,0.4,1.7s0.8,0.4,1.6,0.4c0.8,0,1.3-0.1,1.5-0.3C120.1,62,120.3,61.6,120.3,61z M120.3,58.5l0-0.4
			c0-0.7-0.1-1.2-0.4-1.4c-0.2-0.2-0.8-0.3-1.6-0.3c-0.8,0-1.3,0.1-1.5,0.4s-0.4,0.8-0.4,1.7H120.3z"
                />
                <path
                    class="st1"
                    d="M126.4,57.6h-2.2c0-1.1,0.2-1.8,0.7-2.1s1.5-0.5,2.9-0.5c1.6,0,2.7,0.2,3.2,0.7c0.6,0.4,0.8,1.3,0.8,2.5v5.8
			h-2.1l0.1-1.2l-0.1,0c-0.4,0.9-1.3,1.3-2.8,1.3c-2.1,0-3.2-0.9-3.2-2.7c0-1.8,1.1-2.8,3.3-2.8c1.5,0,2.3,0.3,2.7,1h0v-1.4
			c0-0.7-0.1-1.1-0.4-1.4c-0.2-0.2-0.7-0.3-1.5-0.3C126.9,56.4,126.4,56.8,126.4,57.6z M127.8,59.9c-1.2,0-1.8,0.4-1.8,1.2
			c0,0.6,0.1,0.9,0.4,1.1s0.8,0.3,1.6,0.3c1.3,0,1.9-0.4,1.9-1.3C129.8,60.4,129.1,59.9,127.8,59.9z"
                />
                <path
                    class="st1"
                    d="M134.1,55h2.1l-0.1,1.2l0,0c0.5-0.9,1.3-1.4,2.4-1.4c1.6,0,2.3,1,2.3,2.9v0.6h-2c0-0.2,0-0.4,0-0.5
			c0-0.9-0.4-1.4-1.1-1.4c-1,0-1.6,0.7-1.6,2.1v5.2h-2.1V55z"
                />
                <path
                    class="st1"
                    d="M142,55h2.1l-0.1,1.5l0,0c0.4-1.1,1.3-1.6,2.8-1.6c2.1,0,3.1,1,3.1,2.9v6h-2.1v-5.3v-0.3l0-0.6
			c-0.1-0.7-0.6-1-1.6-1c-1.4,0-2.1,0.7-2.1,2v5.2H142V55z"
                />
                <path class="st1" d="M154.2,51.3V53h-2.1v-1.8H154.2z M154.2,55v8.8h-2.1V55H154.2z" />
                <path
                    class="st1"
                    d="M156.3,55h2.1l-0.1,1.5l0,0c0.4-1.1,1.3-1.6,2.8-1.6c2.1,0,3.1,1,3.1,2.9v6h-2.1v-5.3v-0.3l0-0.6
			c-0.1-0.7-0.6-1-1.6-1c-1.4,0-2.1,0.7-2.1,2v5.2h-2.1V55z"
                />
                <path
                    class="st1"
                    d="M174.2,55v9c0,1.4-0.3,2.4-0.9,3c-0.6,0.5-1.7,0.8-3.2,0.8c-1.5,0-2.5-0.2-3-0.6s-0.8-1.2-0.8-2.4h2.1
			c0,0.6,0.1,0.9,0.3,1.1c0.2,0.2,0.7,0.2,1.4,0.2c1.3,0,2-0.5,2-1.6v-2l0,0c-0.4,0.9-1.2,1.4-2.6,1.4c-1.3,0-2.3-0.3-2.7-1
			c-0.5-0.6-0.7-1.9-0.7-3.6c0-1.7,0.2-2.8,0.7-3.4c0.5-0.6,1.4-1,2.7-1c1.4,0,2.3,0.5,2.8,1.6h0l-0.1-1.5H174.2z M170,56.6
			c-0.8,0-1.3,0.2-1.6,0.5c-0.2,0.3-0.3,1.1-0.3,2.3c0,1.2,0.1,2,0.3,2.4c0.2,0.3,0.8,0.5,1.6,0.5c0.8,0,1.4-0.2,1.6-0.5
			s0.4-1.1,0.4-2.4c0-1.2-0.1-1.9-0.4-2.3S170.9,56.6,170,56.6z"
                />
                <path
                    class="st1"
                    d="M181.1,63.9V51.3h6.2c1.8,0,3,0.4,3.7,1.2c0.7,0.8,1.1,2.1,1.1,4.1c0,3.2-0.3,5.2-0.9,6.1
			c-0.6,0.9-1.8,1.3-3.8,1.3H181.1z M183.5,61.9h3.4c1.1,0,1.9-0.3,2.2-0.8c0.3-0.5,0.5-1.7,0.5-3.5c0-1.9-0.2-3-0.5-3.6
			c-0.3-0.5-1-0.8-2.1-0.8h-3.6V61.9z"
                />
                <path
                    class="st1"
                    d="M199.4,61h2.1v0.3c0,1.7-1.3,2.6-3.9,2.6c-1.8,0-2.9-0.3-3.4-0.9c-0.5-0.6-0.8-1.9-0.8-3.8
			c0-1.7,0.3-2.9,0.9-3.5c0.6-0.6,1.7-0.9,3.3-0.9c1.6,0,2.6,0.3,3.2,0.9c0.5,0.6,0.8,1.7,0.8,3.4v0.6h-6c0,0.2,0,0.3,0,0.4
			c0,0.9,0.1,1.4,0.4,1.7s0.8,0.4,1.6,0.4c0.8,0,1.3-0.1,1.5-0.3C199.3,62,199.4,61.6,199.4,61z M199.5,58.5l0-0.4
			c0-0.7-0.1-1.2-0.4-1.4c-0.2-0.2-0.8-0.3-1.6-0.3c-0.8,0-1.3,0.1-1.5,0.4s-0.4,0.8-0.4,1.7H199.5z"
                />
                <path
                    class="st1"
                    d="M210.7,57.5h-2.1c0-0.1,0-0.1,0-0.2c0-0.4-0.2-0.7-0.4-0.8c-0.2-0.1-0.7-0.2-1.5-0.2c-1.1,0-1.7,0.4-1.7,1.1
			c0,0.5,0.1,0.8,0.3,0.9c0.2,0.1,0.9,0.2,2,0.2c1.5,0.1,2.5,0.3,3,0.6c0.5,0.3,0.7,1,0.7,2c0,1.1-0.3,1.8-0.9,2.2
			c-0.6,0.4-1.7,0.6-3.3,0.6c-1.5,0-2.5-0.2-3.1-0.6c-0.6-0.4-0.8-1.1-0.8-2.1v-0.2h2.2c0,0.1,0,0.2-0.1,0.3
			c-0.1,0.8,0.5,1.2,1.8,1.2c1.3,0,2-0.4,2-1.2c0-0.7-0.4-1.1-1.3-1.1c-1.9,0-3.1-0.2-3.7-0.5s-0.9-1.1-0.9-2.2c0-1,0.3-1.7,0.8-2.1
			c0.5-0.4,1.6-0.5,3.2-0.5c1.5,0,2.5,0.2,3,0.5C210.5,55.8,210.7,56.5,210.7,57.5z"
                />
                <path class="st1" d="M214.8,51.3V53h-2.1v-1.8H214.8z M214.8,55v8.8h-2.1V55H214.8z" />
                <path
                    class="st1"
                    d="M224.8,55v9c0,1.4-0.3,2.4-0.9,3c-0.6,0.5-1.7,0.8-3.2,0.8c-1.5,0-2.5-0.2-3-0.6s-0.8-1.2-0.8-2.4h2.1
			c0,0.6,0.1,0.9,0.3,1.1c0.2,0.2,0.7,0.2,1.4,0.2c1.3,0,2-0.5,2-1.6v-2l0,0c-0.4,0.9-1.2,1.4-2.6,1.4c-1.3,0-2.3-0.3-2.7-1
			c-0.5-0.6-0.7-1.9-0.7-3.6c0-1.7,0.2-2.8,0.7-3.4c0.5-0.6,1.4-1,2.7-1c1.4,0,2.3,0.5,2.8,1.6h0l-0.1-1.5H224.8z M220.6,56.6
			c-0.8,0-1.3,0.2-1.6,0.5c-0.2,0.3-0.3,1.1-0.3,2.3c0,1.2,0.1,2,0.3,2.4c0.2,0.3,0.8,0.5,1.6,0.5c0.8,0,1.4-0.2,1.6-0.5
			s0.4-1.1,0.4-2.4c0-1.2-0.1-1.9-0.4-2.3S221.5,56.6,220.6,56.6z"
                />
                <path
                    class="st1"
                    d="M226.9,55h2.1l-0.1,1.5l0,0c0.4-1.1,1.3-1.6,2.8-1.6c2.1,0,3.1,1,3.1,2.9v6h-2.1v-5.3v-0.3l0-0.6
			c-0.1-0.7-0.6-1-1.6-1c-1.4,0-2.1,0.7-2.1,2v5.2h-2.1V55z"
                />
                <path
                    class="st1"
                    d="M242.6,61h2.1v0.3c0,1.7-1.3,2.6-3.9,2.6c-1.8,0-2.9-0.3-3.4-0.9c-0.5-0.6-0.8-1.9-0.8-3.8
			c0-1.7,0.3-2.9,0.9-3.5c0.6-0.6,1.7-0.9,3.3-0.9c1.6,0,2.6,0.3,3.2,0.9c0.5,0.6,0.8,1.7,0.8,3.4v0.6h-6c0,0.2,0,0.3,0,0.4
			c0,0.9,0.1,1.4,0.4,1.7s0.8,0.4,1.6,0.4c0.8,0,1.3-0.1,1.5-0.3C242.5,62,242.6,61.6,242.6,61z M242.6,58.5l0-0.4
			c0-0.7-0.1-1.2-0.4-1.4c-0.2-0.2-0.8-0.3-1.6-0.3c-0.8,0-1.3,0.1-1.5,0.4s-0.4,0.8-0.4,1.7H242.6z"
                />
                <path
                    class="st1"
                    d="M246.6,55h2.1l-0.1,1.2l0,0c0.5-0.9,1.3-1.4,2.4-1.4c1.6,0,2.3,1,2.3,2.9v0.6h-2c0-0.2,0-0.4,0-0.5
			c0-0.9-0.4-1.4-1.1-1.4c-1,0-1.6,0.7-1.6,2.1v5.2h-2.1V55z"
                />
                <path
                    class="st1"
                    d="M261.9,57.5h-2.1c0-0.1,0-0.1,0-0.2c0-0.4-0.2-0.7-0.4-0.8c-0.2-0.1-0.7-0.2-1.5-0.2c-1.1,0-1.7,0.4-1.7,1.1
			c0,0.5,0.1,0.8,0.3,0.9c0.2,0.1,0.9,0.2,2,0.2c1.5,0.1,2.5,0.3,3,0.6c0.5,0.3,0.7,1,0.7,2c0,1.1-0.3,1.8-0.9,2.2
			c-0.6,0.4-1.7,0.6-3.3,0.6c-1.5,0-2.5-0.2-3.1-0.6c-0.6-0.4-0.8-1.1-0.8-2.1v-0.2h2.2c0,0.1,0,0.2-0.1,0.3
			c-0.1,0.8,0.5,1.2,1.8,1.2c1.3,0,2-0.4,2-1.2c0-0.7-0.4-1.1-1.3-1.1c-1.9,0-3.1-0.2-3.7-0.5s-0.9-1.1-0.9-2.2c0-1,0.3-1.7,0.8-2.1
			c0.5-0.4,1.6-0.5,3.2-0.5c1.5,0,2.5,0.2,3,0.5C261.6,55.8,261.9,56.5,261.9,57.5z"
                />
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "LogoHaikaraWhite",
};
</script>

<style scoped>
.st0 {
    opacity: 0.97;
}
.st1 {
    fill: #ffffff;
}
</style>
